//
//
//
//
//
//
//

export default {
  props: {
    idNextSection: {
      type: String,
      default: '',
    },
  },
}
